/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignPlayersRequest
 */
export interface AssignPlayersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignPlayersRequest
     */
    playerIds: Array<string>;
}

/**
 * Check if a given object implements the AssignPlayersRequest interface.
 */
export function instanceOfAssignPlayersRequest(value: object): value is AssignPlayersRequest {
    if (!('playerIds' in value) || value['playerIds'] === undefined) return false;
    return true;
}

export function AssignPlayersRequestFromJSON(json: any): AssignPlayersRequest {
    return AssignPlayersRequestFromJSONTyped(json, false);
}

export function AssignPlayersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignPlayersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'playerIds': json['playerIds'],
    };
}

export function AssignPlayersRequestToJSON(json: any): AssignPlayersRequest {
    return AssignPlayersRequestToJSONTyped(json, false);
}

export function AssignPlayersRequestToJSONTyped(value?: AssignPlayersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerIds': value['playerIds'],
    };
}

